import { render, staticRenderFns } from "./ScrapRegistrationList.vue?vue&type=template&id=0dda594b&scoped=true&"
import script from "./ScrapRegistrationList.vue?vue&type=script&lang=js&"
export * from "./ScrapRegistrationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda594b",
  null
  
)

export default component.exports